import { Box, Text, Title } from "@mantine/core";
import type { JSX } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { useQuery } from "urql";
import InfoNode from "../InfoNode";
import Loading from "../Loading";
import classes from "./MissingInformation.module.css";
import {
    type MissingInformationRecordQuery,
    type MissingInformationRecordQueryVariables,
    missingInformationRecordQuery,
} from "./queries";

function MissingInformationRecord(): JSX.Element {
    const { recordId } = useParams();
    const [result] = useQuery<MissingInformationRecordQuery, MissingInformationRecordQueryVariables>({
        query: missingInformationRecordQuery,
        variables: {
            recordId: Number.parseInt(recordId!, 10),
        },
    });

    let main = null;
    if (result.fetching) {
        main = <Loading />;
    } else if (result.error) {
        main = <Box>Error: {result.error.message}</Box>;
    } else {
        const record = result.data?.missingInformationRecord;
        if (!record) {
            main = <Box>Record not found</Box>;
        } else {
            main = (
                <>
                    <InfoNode title="Created">
                        <Text span>{new Date(record.created).toLocaleString("en-GB")}</Text>
                    </InfoNode>
                    <InfoNode title="AI Personality">
                        <Text span>{record.personalityName}</Text>
                    </InfoNode>
                    <InfoNode title="Topic">
                        <Text span>{record.topic}</Text>
                    </InfoNode>
                    <InfoNode title="Details">
                        <Text style={{ whiteSpace: "pre-wrap" }}>{record.details}</Text>
                    </InfoNode>
                </>
            );
        }
    }

    return (
        <div className={classes.grid}>
            <Title order={2}>Missing Information Record</Title>
            {main}
            <Link to="..">Back</Link>
        </div>
    );
}

export default MissingInformationRecord;
